import { Component, OnInit, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { AuthService } from "../../shared/services/auth.service";
import { AngularFireAuth } from "@angular/fire/auth";
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import {MenuItem} from 'primeng/api';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit, AfterViewInit{
  displayAdmin: boolean = false;
  menuitems: MenuItem[];

  constructor(
    public authService: AuthService,
    public afs: AngularFirestore,   // Inject Firestore service
    public afAuth: AngularFireAuth, // Inject Firebase auth service
    ) { }

  ngOnInit() {
    this.authService.isAdmin(this.authService.afAuth.auth.currentUser.uid);
    this.adminContent();
    //  this.authService.UpdateUserData(this.afAuth.auth.currentUser);
  }

  ngAfterViewInit(){
    this.menuitems = [
        {label: 'Status: Online', icon: 'pi pi-fw pi-plus'},
        {label: 'Help Centre', icon: 'pi pi-fw pi-download', routerLink: ['/help-centre']},
        {label: 'Logout', icon: 'pi pi-fw pi-refresh', command: () => this.authService.SignOut()}
    ]
    }

  adminContent(){
    if(this.authService.adminContent == true){
      this.displayAdmin = true;
    }else{
      this.displayAdmin = false;
    }
  }

  // changeFont() {
  //   operator === '+' ? this.fontSize++ : this.fontSize--;
  //   (this.para.nativeElement as HTMLParagraphElement).style.fontSize = `${this.fontSize}px`;
  // }

}
